export class GapiUser {
    Id: string;
    Email: string;
    static fromBasicProfile(profile: gapi.auth2.BasicProfile): GapiUser {
        const user: GapiUser = new GapiUser();
        user.Id = profile.getId();
        user.Email = profile.getEmail();
        return user;
    }
}
